import { SB } from '@play-co/replicant';
import { getLocaleConfig } from 'src/replicant/creatives/text';
import {
  createFlexContainer,
  createFlexMessageTemplate,
  createOpenGameAction,
} from './utils';
import { getPetAssetKey, speciesAssetsRatio, speciesChatbot } from './species';
import { buildSender } from '../sender';

/**
 * Assets for back to life messages
 */
export const backToLifeAssets = {
  'background/backToLife': 'private/chatbot/visit/oa_back_to_life.png',
  'text/backToLife_en': 'private/chatbot/visit/back_to_life_en.png',
  'text/backToLife_ja': 'private/chatbot/visit/back_to_life_ja.png',
};

/**
 * Create visited message
 *
 * https://developers.line.biz/en/docs/messaging-api/flex-message-elements/
 * https://developers.line.biz/en/docs/messaging-api/using-flex-messages/
 *
 * Tools for generation of messages in flex format:
 * https://developers.line.biz/flex-simulator/
 */
export const backToLifeMessage = createFlexMessageTemplate(
  SB.object({
    species: SB.tuple(speciesChatbot),
    locale: SB.tuple(['en', 'ja']),
    petName: SB.string(),
  }),
  (data, payload, api) => {
    const text = getLocaleConfig(data.locale).visit.backToLife.text;
    const petAssetKey = getPetAssetKey(data.species, 'happy');
    const petIcon = api.getAssetPath(petAssetKey);

    const template = createFlexContainer(text, {
      type: 'bubble',
      size: 'giga',
      action: createOpenGameAction(text, payload),
      body: {
        type: 'box',
        layout: 'vertical',
        paddingAll: '0px',
        contents: [
          {
            type: 'image',
            url: api.getAssetPath('background/backToLife'),
            size: 'full',
            aspectMode: 'cover',
            gravity: 'center',
            aspectRatio: '1.3:1',
          },
          {
            type: 'box',
            layout: 'vertical',
            contents: [
              {
                type: 'image',
                url: api.getAssetPath(`text/backToLife_${data.locale}`),
                size: 'full',
                aspectRatio: '4:1',
                gravity: 'top',
                offsetTop: '-2%',
              },
            ],
            position: 'absolute',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'flex-start',
          },
          {
            type: 'box',
            layout: 'horizontal',
            position: 'absolute',
            width: '100%',
            height: '100%',
            alignItems: 'flex-end',
            contents: [
              {
                type: 'image',
                url: petIcon,
                aspectRatio: speciesAssetsRatio[petAssetKey],
                size: '25%',
                position: 'relative',
              },
            ],
            offsetTop: '-35%',
            offsetStart: '-2%',
          },
          {
            type: 'box',
            layout: 'vertical',
            contents: [
              {
                type: 'image',
                url: api.getAssetPath(`button/playnow_${data.locale}`),
                position: 'relative',
                size: '55%',
                offsetBottom: '-20%',
              },
            ],
            position: 'absolute',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'flex-end',
          },
        ],
      },
    });

    // Add sender to message
    template['sender'] = buildSender({
      name: data.petName,
      iconUrl: api.getAssetPath(getPetAssetKey(data.species)),
    });

    return template;
  },
);
